import { FormattedWorkflowTemplate } from "@idw-types/data/reference-data/generic";

export enum WorkflowTemplatesActionTypes {
    // Workflow Templates
    SET_WORKFLOW_TEMPLATES_LOADING = "SET_WORKFLOW_TEMPLATES_LOADING",
    SET_WORKFLOW_TEMPLATES = "SET_WORKFLOW_TEMPLATES",
    ADD_WORKFLOW_TEMPLATE = "ADD_WORKFLOW_TEMPLATE"
}

// Workflow Templates
type SetWorkflowTemplatesLoadingAction = {
    type: WorkflowTemplatesActionTypes.SET_WORKFLOW_TEMPLATES_LOADING,
    payload: { isLoading: boolean; }
};

export const setWorkflowTemplatesLoading = (isLoading: boolean): SetWorkflowTemplatesLoadingAction => ({
    type: WorkflowTemplatesActionTypes.SET_WORKFLOW_TEMPLATES_LOADING,
    payload: { isLoading }
});

type SetWorkflowTemplatesAction = {
    type: WorkflowTemplatesActionTypes.SET_WORKFLOW_TEMPLATES,
    payload: { workflowTemplates: Array<FormattedWorkflowTemplate>; }
}

export const setWorkflowTemplates = (workflowTemplates: Array<FormattedWorkflowTemplate>): SetWorkflowTemplatesAction => ({
    type: WorkflowTemplatesActionTypes.SET_WORKFLOW_TEMPLATES,
    payload: { workflowTemplates }
});

type AddWorkflowTemplateAction = {
    type: WorkflowTemplatesActionTypes.ADD_WORKFLOW_TEMPLATE;
    payload: { workflowTemplate: FormattedWorkflowTemplate };
};

export const addWorkflowTemplate = (workflowTemplate: FormattedWorkflowTemplate): AddWorkflowTemplateAction => ({
    type: WorkflowTemplatesActionTypes.ADD_WORKFLOW_TEMPLATE,
    payload: { workflowTemplate }
});

export type WorkflowTemplatesActions =
    // Workflow Templates
    SetWorkflowTemplatesLoadingAction |
    SetWorkflowTemplatesAction |
    AddWorkflowTemplateAction